/**
 * La lectura de los avisos de la sucursal, en un solo lugar.
 *
 * La usan la campanita (la bandeja y su burbuja) y el puente de avisos del
 * telefono (`push-bridge.ts`, el numero en el icono de la app). Con la misma
 * llave, TanStack Query hace UNA lectura para los dos; con dos definiciones,
 * el dia que una cambiara el limite o el intervalo, la burbuja y el icono
 * dirian numeros distintos.
 */

import type { NotificationFeed } from '@abarrotes/shared';
import { api } from './api.js';

export const notificationFeedQuery = (storeId: number) => ({
  queryKey: ['notifications', storeId] as const,
  queryFn: () => api<NotificationFeed>(`/api/stores/${storeId}/notifications`, { query: { limit: 30 } }),
  /*
   * Realtime ya invalida esta consulta cuando entra un aviso, asi que esto no
   * es la via principal: es la red debajo. Si el socket se cayo —el WiFi del
   * changarro, el celular que estuvo bloqueado— la burbuja se quedaria
   * congelada sin que nadie lo note, y el reporte de las 18:15 no aparece
   * hasta la siguiente recarga. Cinco minutos son una llamada barata y hacen
   * que el peor caso sea "tarda un rato" en vez de "no llego".
   */
  refetchInterval: 5 * 60_000,
});
